const USER_CONTACTS_SUBMIT = (state) => {
  state.inProgress = true
  state.error = false
}

const USER_CONTACTS_ERROR_RESPONSE = (state, data) => {
  state.error = true
  state.inProgress = false
}

const FETCH_USER_CONTACTS_RESPONSE = (state, data) => {
  state.additionalSpaceAvailable = data.additionalSpaceAvailable
  state.contacts = data.contacts
  state.inProgress = false
}

const USER_CONTACTS_ADD_CONTACT_RESPONSE = (state, data) => {
  state.inProgress = false
}

const USER_CONTACTS_ADD_CONNECTION_RESPONSE = (state, data) => {
  state.inProgress = false
}

const USER_CONTACTS_EDIT_CONTACT_RESPONSE = (state, data) => {
  state.inProgress = false
}

const USER_CONTACTS_REMOVE_CONNECTION_RESPONSE = (state, data) => {
  state.inProgress = false
}

const USER_CONTACTS_REMOVE_CONTACT_RESPONSE = (state, data) => {
  state.inProgress = false
}

const USER_CONTACTS_FETCH_SPILLOVER_RESPONSE = (state, data) => {
  state.spillover = data
  state.inProgress = false
}

export default {
  USER_CONTACTS_SUBMIT,
  USER_CONTACTS_ERROR_RESPONSE,
  FETCH_USER_CONTACTS_RESPONSE,
  USER_CONTACTS_ADD_CONTACT_RESPONSE,
  USER_CONTACTS_ADD_CONNECTION_RESPONSE,
  USER_CONTACTS_REMOVE_CONNECTION_RESPONSE,
  USER_CONTACTS_EDIT_CONTACT_RESPONSE,
  USER_CONTACTS_REMOVE_CONTACT_RESPONSE,
  USER_CONTACTS_FETCH_SPILLOVER_RESPONSE
}



// WEBPACK FOOTER //
// ./src/store/modules/user/contacts/mutations.js